export type Zoom = {
  xAxisMin?: number;
  xAxisMax?: number;
  yAxisMin?: number;
  yAxisMax?: number;
};

export function uPlotSetZoom(onZoom?: (zoom: Zoom) => void) {
  return (u: uPlot) => {
    const {left, width: selWidth, top, height: selHeight} = u.select;

    // Convert pixel coordinates to data values
    const xMin = u.posToVal(left, 'x');
    const xMax = u.posToVal(left + selWidth, 'x');
    const yMax = u.posToVal(top, 'y'); // top of screen = higher y value
    const yMin = u.posToVal(top + selHeight, 'y'); // bottom of screen = lower y value

    // Clear the selection box
    u.setSelect({left: 0, top: 0, width: 0, height: 0}, false);

    // Call the onZoom callback with new domain values
    onZoom?.({
      xAxisMin: xMin,
      xAxisMax: xMax,
      yAxisMin: yMin,
      yAxisMax: yMax,
    });
  };
}
